import React, { useEffect } from "react";
import {
  Box,
  Fab,
  Button,
  Grid,
  TextField,
  Typography,
  FormControl,
  Divider,
  Card,
  CardContent,
  InputAdornment,
} from "@mui/material";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PoprchModal from "../payment/popSearch";
import { ToDate } from "../../common/toDate";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { format } from "date-fns";
import { addVendor, getVendors } from "./vendorRegistrationApi.js";
import {
  addNewVendor,
  getVendorList,
} from "./vendorRegistrationCustomApiHandler.js";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import AddVendorForm from "./addVendorForm.jsx";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../common/Heading.jsx";

export const VendorRegistration = ({ gridSize }) => {
  const [open, setOpen] = useState();
  const [modalData, setModalData] = useState(null);
  const [vendorsList, setVendorsList] = useState([]);
  const [search, setSearch] = useState("");
  const cardKit = [
    {
      key: "vendorId",
      label: "Vendor ID",
      // color: "#bb4a9b",
    },
    {
      key: "vendorName",
      label: "Vendor Name",
      // color: "#bb4a9b",
    },
    {
      key: "companyAddress",
      label: "Company Address",
    },
    {
      key: "mobileNumber",
      label: "Mobile Number",
    },
  ];

  const getVendorsList = async () => {
    await getVendorList(getVendors, setVendorsList);
  };

  useEffect(() => {
    getVendorsList();
  }, []);

  return (
    <Grid container>
      {/* <DynamicBreadcrumbs /> */}
      <Heading name="Vendor Registration" />

      {/* <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          background:
            "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
          padding: "10px",
          borderRadius: "5px",
          color: "#01008B",
          marginBottom: "20px",
        }}
      >
        <Grid item>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              fontWeight: 500,
            }}
          >
            Vendor Registration
          </Typography>
        </Grid>
      </Grid> */}
      <Grid container spacing={{ sm: 3, xs: 1 }}>
        <Grid item xs={12} sm={9} sx={{ p: 0 }}>
          <TextField
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              width: "100%",
              backgroundColor: "white",
              color: "#555555",
            }}
            size="small"
            id="outlined-basic-search"
            label="Search Vendor"
            // variant="outlined"
            InputLabelProps={{
              className: "mulish",
              sx: {
                color: "#545454",
                fontWeight: 400,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                paddingX: "7px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/* {search ? ( */}
                  {/* <CloseIcon
                    sx={{ cursor: "pointer" }}
                  /> */}
                  {/* ) : ( */}
                  <SearchIcon color="primary" sx={{ cursor: "pointer" }} />
                  {/* )} */}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          item
          // md={2}
          xs={12}
          sm={3}
          sx={{
            paddingRight: "0px",
          }}
        >
          <Button
            fullWidth
            onClick={() => {
              setOpen(true);
              setModalData(null);
            }}
            sx={{
              textTransform: "capitalize",
              // width: {
              //   xs: "70%",
              // },
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              // p: "10px",
              whiteSpace: "nowrap",
            }}
            color="primary"
            variant="contained"
            aria-label="add"
          >
            Add Vendor
            <AddIcon sx={{ marginLeft: "6px" }} />
          </Button>
        </Grid>
      </Grid>

      {/* <Divider
        sx={{
          width: "100%",
          mt: 2,
          background: (theme) => theme.palette.primary.main,
        }}
      /> */}

      {/* <Grid container>
        <Grid container item xs={12}>
          {vendorsList &&
            vendorsList.map((vendor) => (
              <Grid
                item
                xs={gridSize ? gridSize.xs : 12}
                sm={gridSize ? gridSize.sm : 4}
                // md={12}
                // lg={6}
                key={vendor.vendorId}
                sx={{ p: "10px", borderRight: "3px solid #dfdfdf" }}
              >
                <Card
                  sx={{
                    width: "100%",
                    // m: "0px",
                    // mt: "10px",
                    ":hover": {
                      bgcolor: "#2892ba17",
                    },
                    cursor: "pointer",
                    // p: "0rem 0.3rem",
                  }}
                  onClick={() => {
                    setModalData(vendor);
                    setOpen(true);
                  }}
                >
                  <CardContent
                    sx={{ padding: "0.5px 10px !important", margin: "10px" }}
                  >
                    {cardKit.map((row, index) => (
                      <Grid container key={index}>
                        <Grid item xs={6}>
                          <Typography
                            sx={{
                             fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: "1",
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {row.label}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            color="secondary"
                            sx={{
                             fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              overflow: "hidden",
                              color: row?.color || "",
                            }}
                          >
                            {vendor?.[row.key] ?? "N/A"}
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </CardContent>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Grid> */}

      <Grid
        container
        sx={{
          // p: "10px",
          px: { xs: 1, sm: 2 },
          mt: 2,
          background: "white",
          borderRadius: "12px",
          overflowX: "auto",
        }}
      >
        {/* Table Header */}
        <Grid
          container
          sx={{
            borderBottom: "1.5px solid black",
            padding: "10px",
            mb: 0,
          }}
        >
          {cardKit.map((row, index) => (
            <Grid item xs={12 / cardKit.length} key={index}>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  textAlign: "center",
                  fontWeight: 500,
                  color: "#01008B",
                }}
              >
                {row.label}
              </Typography>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            width: "100%",
            maxHeight: "60vh",
            overflowY: "auto",
            mt: 1,
            // pr: 1,
          }}
        >
          {vendorsList
            .filter((vendor) =>
              vendor.vendorName
                .toLowerCase()
                .includes(search.toLocaleLowerCase()),
            )
            .map((vendor, i) => (
              <Grid
                container
                key={vendor.vendorId || i}
                onClick={() => {
                  setModalData(vendor);
                  setOpen(true);
                }}
                sx={{
                  px: 1,
                  py: 1,
                  borderBottom: "1px solid #eee",
                  alignItems: "center",
                  backgroundColor: "#E8E8FF",
                  borderRadius: "8px",
                  mb: 1,
                  cursor: "pointer",
                }}
              >
                {cardKit.map((row, j) => (
                  <Grid
                    item
                    // xs={12 / cardKit.length}
                    xs={3}
                    key={j}
                  >
                    <Typography
                      sx={{
                        textAlign:
                          row.key === "vendorId" || row.key === "mobileNumber"
                            ? "right"
                            : "left",
                        fontWeight: 500,
                        color: row?.color || "inherit",
                        overflow: "hidden",
                        textOverflow:
                          row.key === "companyAddress" ? "ellipsis" : "",
                        whiteSpace: "normal",
                        pr:
                          row.key === "vendorId"
                            ? { xs: 2, sm: 4, md: 8, lg: 14 }
                            : row.key === "mobileNumber"
                              ? { xs: 1, sm: 2, md: 3, lg: 10 } // 👈 different padding for mobile
                              : 0,
                        pl:
                          row.key === "companyAddress"
                            ? { xs: 3, sm: 2, md: 4, lg: 10 }
                            : row.key === "vendorName"
                              ? { xs: 2, sm: 4, md: 6, lg: 12 } // 👈 different padding for mobile
                              : 0,
                        fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      }}
                    >
                      {vendor?.[row.key]?.toString().trim()
                        ? vendor[row.key]
                        : "-"}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            ))}
        </Box>
      </Grid>

      <AddVendorForm
        open={open}
        setOpen={setOpen}
        modalData={modalData}
        setModalData={setModalData}
        getVendorsList={getVendorsList}
      />
    </Grid>
  );
};
